import { fetcher } from '@commenda/utils';

type TDeleteMultipleCapTableTransactionsParams = {
  capTableTransactionIdsToDelete: string[];
};

export const deleteMultipleCapTableTransactions = async (
  params: TDeleteMultipleCapTableTransactionsParams
) => {
  const res = await fetcher(`capTable/transactions`, {
    method: 'DELETE',
    body: params,
  });

  return res;
};
